<template>
  <div class="download-module">
    <v-drop-down-menu
      v-if="$store.state.sceneClassName === 'app'"
      :menu="menu"
      className="app-company-nav"
    ></v-drop-down-menu>
    <div v-else class="nav-footer">
      <div class="nav-footer__content">
        <div class="nav-footer__left">知链助手</div>
        <div class="nav-footer__list">
          <router-link
            to="/download"
            :class="`nav-footer__item ${
              activeRouteName === 'downloadOverview'
                ? 'nav-footer__item-selected'
                : ''
            }`"
          >
            概览
          </router-link>
          <router-link
            to="/download/down"
            :class="`nav-footer__item ${
              activeRouteName === 'downloadDown'
                ? 'nav-footer__item-selected'
                : ''
            }`"
            >下载</router-link
          >
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import DropDownMenu from '@/components/DropDownMenu';
export default {
  data() {
    return {
      activeRouteName: 'downloadOverview',
      menu: [{
        id: 1,
        title: '概览',
        showText: '知链助手',
        link: '/download'
      }, {
        id: 2,
        title: '下载',
        showText: '知链助手',
        link: '/download/down'
      }]
    };
  },
  mounted() {
    this.activeRouteName = this.$route.name;
  },
  watch: {
    $route(to, from) {
      this.activeRouteName = to.name;
    }
  },
  components: {
    'v-drop-down-menu': DropDownMenu
  }
};
</script>

<style lang="scss">
.app .download-module {
  padding-top: 1.04rem;
  .app-company-nav {
    position: fixed;
    top: 1.04rem;
    left: 0;
    width: 100%;
    z-index: 8;
  }
}
</style>
